import React from "react"
import { CustomImage } from "./CustomImage"

interface PersonContactInfoProps {
  thumbnail: string
  image_alt: string
  name: string
  position: string
  mail?: string
  phone: string
  linkedin: string
  xing: string
  webinarInfo?: {
    datetime: string
    datetimeEnd: string
    webinarLocation: string
  }
  calendly?: string
}

export const PersonContactInfo = ({
  thumbnail,
  image_alt,
  name,
  position,
  phone,
  mail,
  xing,
  linkedin,
  webinarInfo,
  calendly,
}: PersonContactInfoProps) => {
  return (
    <div className="w-52 mt-2 pt-4 mb-5">
      <h3
        className={
          "uppercase text-green text-[18px] font-sans font-normal tracking-widest"
        }
      >
        {webinarInfo ? "Moderator" : "Ihr Kontakt"}
      </h3>
      <div className={"w-48 sm:border-t border-gray mt-2 pt-4 mb-5"}>
        <CustomImage src={thumbnail} alt={image_alt} />
      </div>
      <h2 className={"text-[24px] leading-[42.667px] font-semibold font-serif"}>
        {name}
      </h2>
      <p className={"text-green pb-4"}>{position}</p>
      <div className={"grid grid-cols-9 gap-y-2"}>
        {mail && (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="bi bi-envelope-fill w-4 col-span-1 my-auto text-black"
              viewBox="0 0 16 16"
            >
              <path d="M.05 3.555A2 2 0 0 1 2 2h12a2 2 0 0 1 1.95 1.555L8 8.414.05 3.555ZM0 4.697v7.104l5.803-3.558L0 4.697ZM6.761 8.83l-6.57 4.027A2 2 0 0 0 2 14h12a2 2 0 0 0 1.808-1.144l-6.57-4.027L8 9.586l-1.239-.757Zm3.436-.586L16 11.801V4.697l-5.803 3.546Z" />
            </svg>
            <a href={`mailto:${mail}`} className={"col-span-8"}>
              E-Mail senden
            </a>
          </>
        )}
        {phone && (
          <>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              className="bi bi-telephone-fill w-4 col-span-1 my-auto text-black"
              viewBox="0 0 16 16"
            >
              <path
                fillRule="evenodd"
                d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.678.678 0 0 0 .178.643l2.457 2.457a.678.678 0 0 0 .644.178l2.189-.547a1.745 1.745 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.634 18.634 0 0 1-7.01-4.42 18.634 18.634 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877L1.885.511z"
              />
            </svg>
            <a href={`tel:${phone}`} className={"col-span-8 my-auto"}>
              {phone}
            </a>
          </>
        )}
        {linkedin && (
          <>
            <img
              src={"/assets/linkedin.svg"}
              alt={"linkedin logo"}
              className={"h-4 my-auto"}
            />
            <a
              href={linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className={"col-span-8"}
            >
              LinkedIn Profil
            </a>
          </>
        )}
        {xing && (
          <>
            <img
              src={"/assets/xing.svg"}
              alt={"xing logo"}
              className={"h-4 my-auto"}
            />
            <a
              href={xing}
              target="_blank"
              rel="noopener noreferrer"
              className={"col-span-8"}
            >
              Xing Profil
            </a>
          </>
        )}
      </div>
      {webinarInfo && (
        <>
          <h3
            className={
              "mt-6 uppercase text-green text-[18px] font-sans font-normal tracking-widest"
            }
          >
            Termin
          </h3>
          <div className={"w-48 sm:border-t border-gray mt-2 pt-4 mb-5"}>
            <p className={"col-span-8 my-auto"}>
              {new Date(webinarInfo.datetime).toLocaleDateString("de", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
              })}
            </p>
            <p className={"col-span-8 my-auto"}>
              <span>
                {new Date(webinarInfo.datetime).toLocaleTimeString("de", {
                  hour: "2-digit",
                  minute: "2-digit",
                })}{" "}
              </span>
              –
              <span>
                {" "}
                {new Date(webinarInfo.datetimeEnd).toLocaleTimeString("de", {
                  hour: "2-digit",
                  minute: "2-digit",
                })}
              </span>
              Uhr
            </p>
          </div>{" "}
          <h3
            className={
              "mt-6 uppercase text-green text-[18px] font-sans font-normal tracking-widest"
            }
          >
            Ort
          </h3>
          <div className={"w-48 sm:border-t border-gray mt-2 pt-4 mb-5"}>
            <p className={"col-span-8 my-auto"}>
              {webinarInfo.webinarLocation}
            </p>
          </div>
        </>
      )}
    </div>
  )
}
